/* Do NOT modify this file; see /src/_admin/update-version.ts */
/**
 * The current version of quais.
 *
 * @ignore
 */
export const version = '1.0.0-alpha.45';
//# sourceMappingURL=_version.js.map